import { Component, EventEmitter, Input, Output } from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-loading-screen',
  standalone: true,
  imports: [
    MatProgressSpinnerModule, MatIconModule
  ],
  templateUrl: './app-loading-screen.component.html',
  styleUrl: './app-loading-screen.component.scss'
})
export class AppLoadingScreenComponent {
  @Input() error: string | null = null;
  @Input() accessDenied = false;
  @Output() retry = new EventEmitter<void>();
  @Output() signOut = new EventEmitter<void>();
}
